module.exports = __webpack_public_path__ + "img/banner.d6d0976d.png";